










import Vue from 'vue';
import DashboardCounts from '@/components/dashboard/DashboardCounts.vue';
import DashboardChart from '@/components/dashboard/DashboardChart.vue';
import DashboardTable from '@/components/dashboard/DashboardTable.vue';

export default Vue.extend({
  name: 'AdvertiserDashboard',
  components: {
    DashboardCounts,
    DashboardChart,
    DashboardTable,
  },

  mounted() {
    this.$store.commit('changeTitle', this.$t('sidebar.full.dashboard'));
  }
});
